/**
 * Validation field names for the "Delay until event" mode. Shared with the UI.
 *
 * Kept in a file with no imports of its own: `DelayActionNodeInfo` spreads these into its own field
 * names while it loads, and the model reaches `DelayActionNodeInfo` back through the node registry
 * (model -> graphUtils -> registry -> DelayActionNodeInfo). Read from the model, they could be used
 * before the model had finished loading, which breaks hot reloading of this folder.
 */
export const DelayUntilEventFields = {
  EVENTS: 'Events',
  STOP_WAITING_AFTER: 'Stop waiting after',
  NOTIFY_VIA: 'Notify via',
  RECIPIENTS: 'Recipients',
} as const;
